import { render, staticRenderFns } from "./facebookTopic.vue?vue&type=template&id=47891a52"
import script from "./facebookTopic.vue?vue&type=script&lang=js"
export * from "./facebookTopic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports